/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { useLocation, useNavigate } from 'react-router-dom';
import moment from "moment";

/* Helpers, constants, custom methods, internal libraries */
import { useReportsService  } from "../../../../services/reportsService";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../../../constants/appConstants";

/* Components */
import CouponsFilters from "./couponsFilters";
import CouponsGrid from './couponsGrid';

/* Styles */
import styles from "./styles.js"


const CouponsTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();
  const { initAnalytics } = useAnalytics();

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/coupons')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      page: +initialPage,
      bookingStartDate: moment().startOf('year').format('YYYY-MM-DD'),
      bookingEndDate: moment().format('YYYY-MM-DD'),
      travelStartDate: '',
      travelEndDate: '',
    };
  });

  const { couponsResponse, getCouponsList } = useReportsService();

  const enableDownloadButton = couponsResponse?.results?.dataItems.length > 0;

  // useEffect(() => {
  //   const initUtagData = {
  //     channel: 'content',
  //     pageName: PAGE_TITLES["reports"]
  //   };
  //   initAnalytics(initUtagData, 'init call', 'view')
  // }, []);

  useEffect(() => {
    getCouponsList(gridOptions);
    gridOptions.page > 1 ? navigate(`/app/reports/coupons?page=${gridOptions.page}`) : navigate(`/app/reports/coupons`)
  }, [gridOptions]);

  const onRowClick = row => {}

  const handleSort = (column, sortDirection) => {
    setGridOptions({
      ...gridOptions,
      sortby: column.id,
      sortdirection: sortDirection === "desc" ? "dsc" : sortDirection,
    });
  };

  return (
    <div className={classes.couponsTab}>
      <CouponsFilters
        response={couponsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        type="REPORTS"
        enableDownloadButton={enableDownloadButton}
      />
      <CouponsGrid
        couponsResponse={couponsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        onRowClick={onRowClick}
        handleSort={handleSort}
        defaultSort={couponsResponse?.defaultSort}
      />
    </div>
  )
}

export default CouponsTab;
